const TokenKey = 'sphz-user-app'
import { getTicket } from '@/api' 

export function getToken() {
  console.log(localStorage.getItem(TokenKey))
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  console.log('remove')
  return localStorage.removeItem(TokenKey)
}

export function wxInit() {
  // return;
  let url = location.href.split('#')[0];
  getTicket(url).then((res) => {
    if (res.data && res.data.ticket) {
      let config = {
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.ticket.timestamp,
        nonceStr: res.data.ticket.nonceStr,
        signature: res.data.ticket.signature,
        jsApiList: [
          'onMenuShareAppMessage', 'onMenuShareTimeline', 
          'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem',
          'updateAppMessageShareData', 'updateTimelineShareData',
        ]
      }
      wx.config(config);
    }
  })
}